import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { IoClose } from "react-icons/io5";

const AddDepartmentModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      
      {/* HEADER */}
      <div
        style={{
          padding: "16px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
          fontSize: "18px",
        }}
      >
        Add Department

        <div
          onClick={handleClose}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            background: "#6b7280",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <IoClose size={16} />
        </div>
      </div>

      {/* BODY */}
      <div style={{ padding: "20px" }}>
        <Form>
          
          {/* NAME */}
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Department Name</Form.Label>
            <Form.Control style={{ height: "42px" }} />
          </Form.Group>

          {/* STATUS */}
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select style={{ height: "42px" }}>
              <option>Select</option>
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </Form.Group>

        </Form>
      </div>

      {/* FOOTER */}
      <div
        style={{
          borderTop: "1px solid #e5e7eb",
          padding: "14px 20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <Button
          onClick={handleClose}
          style={{
            background: "#f3f4f6",
            border: "1px solid #e5e7eb",
            color: "#111827",
          }}
        >
          Cancel
        </Button>

        <Button
          style={{
            background: "#f97316",
            border: "none",
          }}
        >
          Add Department
        </Button>
      </div>
    </Modal>
  );
};

export default AddDepartmentModal;